// PWAVisibility.tsx
import React from "react";
import { useIsPWA } from "../../../utils/useIsPWA";

type Props = {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  invert?: boolean; // jeśli true → pokazuje tylko w nie-PWA
};

export function PWAVisibility({ children, fallback = null, invert = false }: Props) {
  const isPWA = useIsPWA();

  // tryb standardowy → pokazuj w PWA
  if (!invert) {
    return isPWA ? <>{children}</> : <>{fallback}</>;
  }

  // tryb invert → pokazuj w NIE-PWA
  return !isPWA ? <>{children}</> : <>{fallback}</>;
}
